import * as React from 'react';
import styled from 'styled-components';
import loading from 'src/assets/loading.gif';

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const MatchingText = styled.span`
  font-family: 'Inter UI';
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  font-size: 14px;
  text-align: center;
  margin-top: 12px;

  color: #00144d;

  span {
    font-weight: bold;
  }
`;

const LoadingImage = styled.img`
  width: 58px;
  height: 58px;
`;

const LoadingPage = () => {
  return (
    <LoadingContainer>
      <LoadingImage src={loading} />
      <MatchingText>
        <span>Matching</span>
        <br />
        Contacting Hosts...
      </MatchingText>
    </LoadingContainer>
  );
};

export default LoadingPage;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/components/LoadingPage.tsx